import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import WrapperComponent from '../commonComponents/WrapperComponent';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { url } from '../../util/config';

const CONNECTOR_META = {
    custom:          { label: 'Custom API',      icon: '🔧', color: '#1565c0', bg: '#eff6ff' },
    google_calendar: { label: 'Google Calendar', icon: '📅', color: '#16a34a', bg: '#f0fdf4' },
    razorpay:        { label: 'Razorpay',        icon: '💳', color: '#7c3aed', bg: '#faf5ff' },
    shopify:         { label: 'Shopify',         icon: '🛍️', color: '#16a34a', bg: '#f0fdf4' },
    zoho_crm:        { label: 'Zoho CRM',        icon: '👥', color: '#d97706', bg: '#fffbeb' },
};

const METHOD_COLORS = {
    GET:    { color: '#16a34a', bg: '#f0fdf4' },
    POST:   { color: '#1565c0', bg: '#eff6ff' },
    PUT:    { color: '#d97706', bg: '#fffbeb' },
    PATCH:  { color: '#7c3aed', bg: '#faf5ff' },
    DELETE: { color: '#dc2626', bg: '#fef2f2' },
};

function ToolCard({ tool, onEdit, onDelete, onTest }) {
    const [menuOpen,    setMenuOpen]    = useState(false);
    const [confirmDel,  setConfirmDel]  = useState(false);
    const [deleting,    setDeleting]    = useState(false);
    const connector = CONNECTOR_META[tool.connector_type] || CONNECTOR_META.custom;
    const method    = METHOD_COLORS[tool.method] || METHOD_COLORS.GET;

    const handleDelete = async () => {
        setDeleting(true);
        await onDelete(tool);
        setDeleting(false);
        setConfirmDel(false);
    };

    return (
        <div style={{ background: '#fff', border: `1px solid ${confirmDel ? '#fca5a5' : '#e5e7eb'}`, borderRadius: 16, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', transition: 'all 0.2s', display: 'flex', flexDirection: 'column' }}
            onMouseEnter={e => { if (!confirmDel) e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.1)'; }}
            onMouseLeave={e => e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.06)'}>

            {/* Inline delete confirmation */}
            {confirmDel && (
                <div style={{ padding: '12px 16px', background: '#fef2f2', borderBottom: '1px solid #fecaca', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                    <div>
                        <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: '#dc2626' }}>Delete "{tool.name}"?</p>
                        <p style={{ margin: '2px 0 0', fontSize: 11, color: '#6b7280' }}>This cannot be undone. Agents using this tool will lose access.</p>
                    </div>
                    <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                        <button onClick={() => setConfirmDel(false)}
                            style={{ padding: '6px 12px', fontSize: 12, fontWeight: 600, border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff', color: '#374151', cursor: 'pointer' }}>
                            Cancel
                        </button>
                        <button onClick={handleDelete} disabled={deleting}
                            style={{ padding: '6px 12px', fontSize: 12, fontWeight: 700, border: 'none', borderRadius: 8, background: '#dc2626', color: '#fff', cursor: deleting ? 'not-allowed' : 'pointer' }}>
                            {deleting ? 'Deleting...' : 'Delete'}
                        </button>
                    </div>
                </div>
            )}

            {/* Card body */}
            <div style={{ padding: '18px 18px 14px', flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 12 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ width: 42, height: 42, borderRadius: 12, background: connector.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0 }}>
                            {tool.icon || connector.icon}
                        </div>
                        <div>
                            <p style={{ fontSize: 14, fontWeight: 700, color: '#111827', margin: 0 }}>{tool.name}</p>
                            <p style={{ fontSize: 11, color: '#6b7280', margin: '2px 0 0' }}>{tool.description}</p>
                        </div>
                    </div>
                    <div style={{ position: 'relative' }}>
                        <button onClick={() => setMenuOpen(p => !p)}
                            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px 8px', color: '#9ca3af', fontSize: 16 }}
                            onBlur={() => setTimeout(() => setMenuOpen(false), 150)}>
                            <i className="bi bi-three-dots-vertical"></i>
                        </button>
                        {menuOpen && (
                            <div style={{ position: 'absolute', right: 0, top: '110%', background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.12)', zIndex: 50, minWidth: 150, overflow: 'hidden' }}
                                onMouseLeave={() => setMenuOpen(false)}>
                                {[
                                    { label: 'Edit Tool',  icon: 'bi-pencil',     color: '#374151', action: () => { onEdit(tool); setMenuOpen(false); } },
                                    { label: 'Test Tool',  icon: 'bi-play-circle', color: '#16a34a', action: () => { onTest(tool); setMenuOpen(false); } },
                                    { label: 'Delete',     icon: 'bi-trash',      color: '#dc2626', action: () => { setConfirmDel(true); setMenuOpen(false); } },
                                ].map((item, i) => (
                                    <button key={i} onClick={item.action}
                                        style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 14px', width: '100%', border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 13, color: item.color, textAlign: 'left' }}
                                        onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                                        <i className={`bi ${item.icon}`} style={{ fontSize: 12 }}></i> {item.label}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Badges */}
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 12 }}>
                    <span style={{ fontSize: 10, fontWeight: 700, padding: '3px 8px', borderRadius: 10, background: method.bg, color: method.color }}>
                        {tool.method}
                    </span>
                    <span style={{ fontSize: 10, fontWeight: 700, padding: '3px 8px', borderRadius: 10, background: connector.bg, color: connector.color }}>
                        {connector.icon} {connector.label}
                    </span>
                    {!tool.is_active && (
                        <span style={{ fontSize: 10, fontWeight: 700, padding: '3px 8px', borderRadius: 10, background: '#f9fafb', color: '#6b7280' }}>
                            Inactive
                        </span>
                    )}
                </div>

                {/* URL */}
                <p style={{ fontSize: 11, color: '#9ca3af', margin: 0, fontFamily: 'monospace', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {tool.url}
                </p>

                {/* Stats */}
                <div style={{ display: 'flex', gap: 14, marginTop: 10 }}>
                    <span style={{ fontSize: 11, color: '#6b7280', display: 'flex', alignItems: 'center', gap: 4 }}>
                        <i className="bi bi-sliders" style={{ fontSize: 10 }}></i>
                        {tool.params?.length || 0} params
                    </span>
                    <span style={{ fontSize: 11, color: '#6b7280', display: 'flex', alignItems: 'center', gap: 4 }}>
                        <i className="bi bi-arrow-return-left" style={{ fontSize: 10 }}></i>
                        {tool.response_mapping?.length || 0} mappings
                    </span>
                </div>
            </div>

            {/* Footer */}
            <div style={{ padding: '10px 18px', borderTop: '1px solid #f3f4f6', background: '#fafafa', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ fontSize: 11, color: '#9ca3af' }}>
                    {new Date(tool.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
                </span>
                <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={() => onTest(tool)}
                        style={{ padding: '5px 12px', background: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0', borderRadius: 8, cursor: 'pointer', fontSize: 11, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 4 }}>
                        <i className="bi bi-play-fill" style={{ fontSize: 10 }}></i> Test
                    </button>
                    <button onClick={() => onEdit(tool)}
                        style={{ padding: '5px 12px', background: '#eff6ff', color: '#1565c0', border: '1px solid #bfdbfe', borderRadius: 8, cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>
                        Edit
                    </button>
                </div>
            </div>
        </div>
    );
}

export default function Tools() {
    const navigate = useNavigate();
    const [tools,   setTools]   = useState([]);
    const [loading, setLoading] = useState(true);
    const [search,  setSearch]  = useState('');
    const [filter,  setFilter]  = useState('all');
    const [testTool, setTestTool] = useState(null);
    const token = localStorage.getItem('token');

    const fetchTools = async () => {
        setLoading(true);
        try {
            const res  = await fetch(`${url}/tools`, { headers: { Authorization: `Bearer ${token}` } });
            const data = await res.json();
            if (data.success) setTools(data.data);
        } catch (e) { toast.error('Failed to load tools'); }
        setLoading(false);
    };

    useEffect(() => { fetchTools(); }, []);

    const handleDelete = async (tool) => {
        try {
            const res  = await fetch(`${url}/tools/${tool._id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
            const data = await res.json();
            if (data.success) { toast.success('Tool deleted'); fetchTools(); }
            else toast.error(data.error);
        } catch (e) { toast.error('Delete failed'); }
    };

    const displayed = tools
        .filter(t => filter === 'all' ? true : t.connector_type === filter)
        .filter(t => !search || t.name.toLowerCase().includes(search.toLowerCase()) || t.description.toLowerCase().includes(search.toLowerCase()));

    return (
        <WrapperComponent>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 20, fontFamily: "'Segoe UI', system-ui, sans-serif" }}>

                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
                    <div>
                        <h5 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#111827' }}>Tool Registry</h5>
                        <p style={{ margin: '4px 0 0', fontSize: 13, color: '#6b7280' }}>
                            Define API tools your agents can call autonomously during conversations.
                        </p>
                    </div>
                    <button onClick={() => navigate('/tools/create')}
                        style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 20px', background: 'linear-gradient(135deg, #1565c0, #1e40af)', color: '#fff', border: 'none', borderRadius: 12, cursor: 'pointer', fontSize: 14, fontWeight: 700, boxShadow: '0 2px 8px rgba(21,101,192,0.3)' }}>
                        <i className="bi bi-plus-lg"></i> Add Tool
                    </button>
                </div>

                {/* Stats */}
                <div style={{ display: 'flex', gap: 12 }}>
                    {[
                        { label: 'Total Tools', value: tools.length,                                          color: '#1565c0', bg: '#eff6ff', border: '#bfdbfe' },
                        { label: 'Active',      value: tools.filter(t => t.is_active).length,                color: '#16a34a', bg: '#f0fdf4', border: '#bbf7d0' },
                        { label: 'Custom APIs', value: tools.filter(t => t.connector_type === 'custom').length, color: '#7c3aed', bg: '#faf5ff', border: '#e9d5ff' },
                    ].map(s => (
                        <div key={s.label} style={{ padding: '12px 20px', background: s.bg, border: `1px solid ${s.border}`, borderRadius: 12, display: 'flex', gap: 10, alignItems: 'center' }}>
                            <span style={{ fontSize: 24, fontWeight: 800, color: s.color }}>{s.value}</span>
                            <span style={{ fontSize: 12, color: '#6b7280' }}>{s.label}</span>
                        </div>
                    ))}
                </div>

                {/* Filter + Search */}
                <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                        {[['all', 'All'], ...Object.entries(CONNECTOR_META).map(([k, v]) => [k, `${v.icon} ${v.label}`])].map(([val, lbl]) => (
                            <button key={val} onClick={() => setFilter(val)}
                                style={{ padding: '6px 14px', fontSize: 11, fontWeight: 600, borderRadius: 20, border: `1.5px solid ${filter === val ? '#1565c0' : '#e5e7eb'}`, background: filter === val ? '#eff6ff' : '#fff', color: filter === val ? '#1565c0' : '#374151', cursor: 'pointer' }}>
                                {lbl}
                            </button>
                        ))}
                    </div>
                    <div style={{ flex: 1, minWidth: 180, position: 'relative' }}>
                        <i className="bi bi-search" style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#9ca3af', fontSize: 12 }}></i>
                        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search tools..."
                            style={{ width: '100%', padding: '8px 12px 8px 30px', border: '1.5px solid #e5e7eb', borderRadius: 10, fontSize: 13, outline: 'none', boxSizing: 'border-box' }}/>
                    </div>
                </div>

                {/* Grid */}
                {loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}>
                        <div className="spinner-border text-primary" style={{ width: '2rem', height: '2rem' }}></div>
                    </div>
                ) : displayed.length === 0 ? (
                    <div style={{ background: '#fff', border: '2px dashed #e5e7eb', borderRadius: 20, padding: 80, textAlign: 'center' }}>
                        <div style={{ fontSize: 48, marginBottom: 16 }}>🔧</div>
                        <p style={{ fontSize: 18, fontWeight: 700, color: '#111827', margin: 0 }}>
                            {search || filter !== 'all' ? 'No tools match your filter' : 'No tools yet'}
                        </p>
                        <p style={{ fontSize: 13, color: '#6b7280', margin: '8px 0 24px' }}>
                            {search || filter !== 'all' ? 'Try different search' : 'Add your first API tool and attach it to an agent'}
                        </p>
                        {!search && filter === 'all' && (
                            <button onClick={() => navigate('/tools/create')}
                                style={{ padding: '12px 24px', background: '#1565c0', color: '#fff', border: 'none', borderRadius: 12, cursor: 'pointer', fontSize: 14, fontWeight: 700 }}>
                                <i className="bi bi-plus-lg" style={{ marginRight: 8 }}></i>Add Your First Tool
                            </button>
                        )}
                    </div>
                ) : (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 20 }}>
                        {displayed.map(tool => (
                            <ToolCard key={tool._id} tool={tool}
                                onEdit={t => navigate(`/tools/create?id=${t._id}`)}
                                onDelete={handleDelete}
                                onTest={t => setTestTool(t)}
                            />
                        ))}
                    </div>
                )}

                {/* Test Panel */}
                {testTool && (
                    <TestPanel tool={testTool} token={token} url={url}
                        onClose={() => setTestTool(null)}/>
                )}
            </div>
            <ToastContainer/>
        </WrapperComponent>
    );
}

// ── Test Panel ────────────────────────────────────────────────────────────────
function TestPanel({ tool, token, url, onClose }) {
    const [params,   setParams]   = useState({});
    const [result,   setResult]   = useState(null);
    const [testing,  setTesting]  = useState(false);

    const runTest = async () => {
        setTesting(true);
        setResult(null);
        try {
            const res  = await fetch(`${url}/tools/${tool._id}/test`, {
                method:  'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body:    JSON.stringify({ params }),
            });
            const data = await res.json();
            setResult(data);
        } catch (e) { setResult({ success: false, error: e.message }); }
        setTesting(false);
    };

    return (
        <>
            <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.3)', zIndex: 199 }}/>
            <div style={{ position: 'fixed', top: 0, right: 0, width: 420, height: '100vh', background: '#fff', boxShadow: '-4px 0 24px rgba(0,0,0,0.12)', zIndex: 200, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                {/* Header */}
                <div style={{ padding: '18px 20px', borderBottom: '1px solid #f3f4f6', display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ fontSize: 24 }}>{tool.icon || '🔧'}</span>
                    <div style={{ flex: 1 }}>
                        <p style={{ fontSize: 15, fontWeight: 700, color: '#111827', margin: 0 }}>Test: {tool.name}</p>
                        <p style={{ fontSize: 11, color: '#6b7280', margin: 0 }}>{tool.method} {tool.url}</p>
                    </div>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280', fontSize: 18 }}>
                        <i className="bi bi-x-lg"></i>
                    </button>
                </div>

                {/* Content */}
                <div style={{ flex: 1, overflowY: 'auto', padding: 20 }}>
                    {/* Params */}
                    {tool.params?.length > 0 && (
                        <div style={{ marginBottom: 20 }}>
                            <p style={{ fontSize: 12, fontWeight: 700, color: '#374151', marginBottom: 12 }}>Test Parameters</p>
                            {tool.params.map((p, i) => (
                                <div key={i} style={{ marginBottom: 12 }}>
                                    <label style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', display: 'block', marginBottom: 4 }}>
                                        {p.name} {p.required && <span style={{ color: '#dc2626' }}>*</span>}
                                        <span style={{ fontWeight: 400, marginLeft: 6 }}>— {p.description}</span>
                                    </label>
                                    <input value={params[p.name] || ''} onChange={e => setParams(prev => ({ ...prev, [p.name]: e.target.value }))}
                                        placeholder={`Enter ${p.name}`}
                                        style={{ width: '100%', padding: '8px 12px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 13, outline: 'none', boxSizing: 'border-box' }}/>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Run button */}
                    <button onClick={runTest} disabled={testing}
                        style={{ width: '100%', padding: '12px', background: testing ? '#d1d5db' : 'linear-gradient(135deg, #16a34a, #15803d)', color: '#fff', border: 'none', borderRadius: 10, cursor: testing ? 'not-allowed' : 'pointer', fontSize: 14, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                        {testing ? <><div className="spinner-border spinner-border-sm text-light" style={{ width: '1rem', height: '1rem' }}></div> Testing...</>
                            : <><i className="bi bi-play-fill"></i> Run Test</>}
                    </button>

                    {/* Result */}
                    {result && (
                        <div style={{ marginTop: 20 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                                <span style={{ fontSize: 12, fontWeight: 700, color: result.success ? '#16a34a' : '#dc2626' }}>
                                    {result.success ? '✅ Success' : '❌ Failed'}
                                </span>
                                {result.status && <span style={{ fontSize: 11, color: '#6b7280' }}>HTTP {result.status}</span>}
                                {result.duration_ms && <span style={{ fontSize: 11, color: '#6b7280' }}>{result.duration_ms}ms</span>}
                            </div>

                            {/* Mapped values */}
                            {result.mapped && Object.keys(result.mapped).length > 0 && (
                                <div style={{ marginBottom: 12 }}>
                                    <p style={{ fontSize: 11, fontWeight: 700, color: '#374151', margin: '0 0 8px' }}>Extracted Values:</p>
                                    {Object.entries(result.mapped).map(([k, v]) => (
                                        <div key={k} style={{ display: 'flex', gap: 8, padding: '6px 10px', background: '#f0fdf4', borderRadius: 6, marginBottom: 4 }}>
                                            <span style={{ fontSize: 11, fontWeight: 700, color: '#16a34a', fontFamily: 'monospace' }}>{k}:</span>
                                            <span style={{ fontSize: 11, color: '#374151' }}>{String(v)}</span>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* Raw response */}
                            <p style={{ fontSize: 11, fontWeight: 700, color: '#374151', margin: '0 0 8px' }}>Raw Response:</p>
                            <pre style={{ background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 8, padding: 12, fontSize: 11, overflow: 'auto', maxHeight: 300, margin: 0 }}>
                                {JSON.stringify(result.response || result.error, null, 2)}
                            </pre>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
